module.exports = __webpack_public_path__ + "static/media/10046.8ad6de94.jpg";